import {
  asSequence2phdjljfh9jhx as asSequence,
  first58ocm7j58k3q as first,
  plus310ted5e4i90h as plus,
  first28gmhyvs4kf06 as first_0,
  toSet2orjxp16sotqu as toSet,
  union28sojvmrkgw6y as union,
  intersect7qttw6wlmz1n as intersect,
  plus20p0vtfmu0596 as plus_0,
  toList3jhuyej2anx2q as toList,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  flatMapgxtanzi5fvh9 as flatMap,
  mapsbvh18eqox7a as map,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Conditionlbcfpsbet24r as Condition,
  Never_getInstance3of1faxayn0qw as Never_getInstance,
  Always_getInstance177eud73uc475 as Always_getInstance,
  Or37bzl6q9twftg as Or,
  And1a3dbpwh0hxmu as And,
  OnField2kq8b4gk936v8 as OnField,
  NotEqual3by2u1rdr6xhj as NotEqual,
  NotInside2gyw9f0e86unn as NotInside,
  Equal31pr842ymh8s6 as Equal,
  Inside34e21e5w7gmr5 as Inside,
  LessThan328qpp4kkt6qa as LessThan,
  GreaterThan3vt01ywx1j4sj as GreaterThan,
  Neverceenm6qv9xac as Never,
  Always2gnog82xa5sk4 as Always,
  LessThanOrEqual3o5tj78evuy34 as LessThanOrEqual,
  GreaterThanOrEqual3ghjzsakr35no as GreaterThanOrEqual,
} from './Condition.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { sequenceOfdrc6uefhtiet as sequenceOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/Sequences.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  minus165a8u1e0x1lu as minus,
  minus27abgkurcn6u0 as minus_0,
  plus18eogev54fmsa as plus_1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SerializableProperty3cbm268cpjr8q as SerializableProperty } from './SerializableProperty.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function simplify(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof And()) {
    var tmp_0 = asSequence(_this__u8e3s4.conditions_1);
    // Inline function 'kotlin.sequences.groupBy' call
    var tmp0 = flatMap(tmp_0, simplify$lambda);
    // Inline function 'kotlin.sequences.groupByTo' call
    var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var key = element.first_1;
      // Inline function 'kotlin.collections.getOrPut' call
      var value = destination.get_wei43m_k$(key);
      var tmp_1;
      if (value == null) {
        var answer = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        destination.put_4fpzoq_k$(key, answer);
        tmp_1 = answer;
      } else {
        tmp_1 = value;
      }
      var list = tmp_1;
      list.add_utx5q5_k$(element);
    }
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = destination.get_entries_p20ztl_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      var tmp$ret$10;
      $l$block: {
        // Inline function 'kotlin.collections.map' call
        var this_0 = element_0.get_value_j01efc_k$();
        // Inline function 'kotlin.collections.mapTo' call
        var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s_1 = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s_1.next_20eer_k$();
          var tmp_2 = item.second_1;
          var tmp$ret$13 = tmp_2 instanceof Condition() ? tmp_2 : THROW_CCE();
          destination_1.add_utx5q5_k$(tmp$ret$13);
        }
        // Inline function 'kotlin.collections.reduce' call
        var iterator = destination_1.iterator_jk1svi_k$();
        if (!iterator.hasNext_bitz1p_k$())
          throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$("Empty collection can't be reduced.");
        var accumulator = iterator.next_20eer_k$();
        while (iterator.hasNext_bitz1p_k$()) {
          var tmp0_0 = accumulator;
          var p1 = iterator.next_20eer_k$();
          accumulator = reduceAnd(tmp0_0, p1);
        }
        var tmp$ret$14 = accumulator;
        var keyCond = finalSimplify(tmp$ret$14);
        var tmp_3;
        if (keyCond.equals(Always_getInstance())) {
          tmp$ret$10 = null;
          break $l$block;
        } else if (keyCond.equals(Never_getInstance())) {
          return Never_getInstance();
        } else {
          var tmp_4 = make(element_0.get_key_18j28a_k$(), keyCond);
          tmp_3 = tmp_4 instanceof Condition() ? tmp_4 : THROW_CCE();
        }
        tmp$ret$10 = tmp_3;
      }
      var tmp0_safe_receiver = tmp$ret$10;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.add_utx5q5_k$(tmp0_safe_receiver);
      }
    }
    // Inline function 'kotlin.let' call
    tmp = destination_0.isEmpty_y1axqb_k$() ? Always_getInstance() : destination_0.get_size_woubt6_k$() === 1 ? first(destination_0) : And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(destination_0);
  } else {
    if (_this__u8e3s4 instanceof Or()) {
      var tmp_5 = asSequence(_this__u8e3s4.conditions_1);
      // Inline function 'kotlin.sequences.groupBy' call
      var tmp0_1 = flatMap(tmp_5, simplify$lambda_0);
      // Inline function 'kotlin.sequences.groupByTo' call
      var destination_2 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
      var _iterator__ex2g4s_2 = tmp0_1.iterator_jk1svi_k$();
      while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
        var element_1 = _iterator__ex2g4s_2.next_20eer_k$();
        var key_0 = element_1.first_1;
        // Inline function 'kotlin.collections.getOrPut' call
        var value_0 = destination_2.get_wei43m_k$(key_0);
        var tmp_6;
        if (value_0 == null) {
          var answer_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          destination_2.put_4fpzoq_k$(key_0, answer_0);
          tmp_6 = answer_0;
        } else {
          tmp_6 = value_0;
        }
        var list_0 = tmp_6;
        list_0.add_utx5q5_k$(element_1);
      }
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_3 = destination_2.get_entries_p20ztl_k$().iterator_jk1svi_k$();
      while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
        var element_2 = _iterator__ex2g4s_3.next_20eer_k$();
        var tmp$ret$30;
        $l$block_0: {
          // Inline function 'kotlin.collections.map' call
          var this_1 = element_2.get_value_j01efc_k$();
          // Inline function 'kotlin.collections.mapTo' call
          var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s_4 = this_1.iterator_jk1svi_k$();
          while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
            var item_0 = _iterator__ex2g4s_4.next_20eer_k$();
            var tmp_7 = item_0.second_1;
            var tmp$ret$33 = tmp_7 instanceof Condition() ? tmp_7 : THROW_CCE();
            destination_4.add_utx5q5_k$(tmp$ret$33);
          }
          // Inline function 'kotlin.collections.reduce' call
          var iterator_0 = destination_4.iterator_jk1svi_k$();
          if (!iterator_0.hasNext_bitz1p_k$())
            throw UnsupportedOperationException().new_kotlin_UnsupportedOperationException_chzcdl_k$("Empty collection can't be reduced.");
          var accumulator_0 = iterator_0.next_20eer_k$();
          while (iterator_0.hasNext_bitz1p_k$()) {
            var tmp0_2 = accumulator_0;
            var p1_0 = iterator_0.next_20eer_k$();
            accumulator_0 = reduceOr(tmp0_2, p1_0);
          }
          var tmp$ret$34 = accumulator_0;
          var keyCond_0 = finalSimplify(tmp$ret$34);
          var tmp_8;
          if (keyCond_0.equals(Always_getInstance())) {
            return Always_getInstance();
          } else if (keyCond_0.equals(Never_getInstance())) {
            tmp$ret$30 = null;
            break $l$block_0;
          } else {
            var tmp_9 = make(element_2.get_key_18j28a_k$(), keyCond_0);
            tmp_8 = tmp_9 instanceof Condition() ? tmp_9 : THROW_CCE();
          }
          tmp$ret$30 = tmp_8;
        }
        var tmp0_safe_receiver_0 = tmp$ret$30;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_3.add_utx5q5_k$(tmp0_safe_receiver_0);
        }
      }
      // Inline function 'kotlin.let' call
      tmp = destination_3.isEmpty_y1axqb_k$() ? Never_getInstance() : destination_3.get_size_woubt6_k$() === 1 ? first(destination_3) : Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(destination_3);
    } else {
      tmp = finalSimplify(_this__u8e3s4);
    }
  }
  return tmp;
}
function andByField(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof And()) {
    var tmp_0 = asSequence(_this__u8e3s4.conditions_1);
    tmp = flatMap(tmp_0, andByField$lambda);
  } else {
    if (_this__u8e3s4 instanceof OnField()) {
      var tmp_1 = andByField(_this__u8e3s4.condition_1);
      tmp = map(tmp_1, (it) => to(plus(listOf_0(_this__u8e3s4.key_1), it.first_1), it.second_1));
    } else {
      var s = simplify(_this__u8e3s4);
      var tmp_2;
      if (s instanceof OnField()) {
        var tmp_3 = andByField(s.condition_1);
        tmp_2 = map(tmp_3, (it) => to(plus(listOf_0(s.key_1), it.first_1), it.second_1));
      } else {
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_2 = sequenceOf(to(tmp$ret$0, s));
      }
      tmp = tmp_2;
    }
  }
  return tmp;
}
function finalSimplify(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof And()) {
    var tmp_0;
    var tmp0 = _this__u8e3s4.conditions_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(tmp0, Collection())) {
        tmp_1 = tmp0.isEmpty_y1axqb_k$();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
      while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
        var element = _iterator__ex2g4s.next_20eer_k$();
        if (element.equals(Never_getInstance())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    if (tmp$ret$0) {
      tmp_0 = Never_getInstance();
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp = tmp_0;
  } else {
    if (_this__u8e3s4 instanceof Or()) {
      var tmp_2;
      var tmp0_0 = _this__u8e3s4.conditions_1;
      var tmp$ret$2;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(tmp0_0, Collection())) {
          tmp_3 = tmp0_0.isEmpty_y1axqb_k$();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$2 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
          if (element_0.equals(Always_getInstance())) {
            tmp$ret$2 = true;
            break $l$block_2;
          }
        }
        tmp$ret$2 = false;
      }
      if (tmp$ret$2) {
        tmp_2 = Always_getInstance();
      } else {
        tmp_2 = _this__u8e3s4;
      }
      tmp = tmp_2;
    } else {
      if (_this__u8e3s4 instanceof Inside()) {
        switch (_this__u8e3s4.values_1.get_size_woubt6_k$()) {
          case 0:
            tmp = Never_getInstance();
            break;
          case 1:
            tmp = Equal().new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(first_0(_this__u8e3s4.values_1));
            break;
          default:
            tmp = _this__u8e3s4;
            break;
        }
      } else {
        if (_this__u8e3s4 instanceof NotInside()) {
          switch (_this__u8e3s4.values_1.get_size_woubt6_k$()) {
            case 0:
              tmp = Always_getInstance();
              break;
            case 1:
              tmp = NotEqual().new_com_lightningkite_services_database_Condition_NotEqual_vy8bqe_k$(first_0(_this__u8e3s4.values_1));
              break;
            default:
              tmp = _this__u8e3s4;
              break;
          }
        } else {
          tmp = _this__u8e3s4;
        }
      }
    }
  }
  return tmp;
}
function reduceAnd(a, b) {
  var tmp;
  if (a instanceof Always()) {
    tmp = b;
  } else {
    if (a instanceof Never()) {
      tmp = a;
    } else {
      if (a instanceof And()) {
        var tmp_0;
        if (b instanceof And()) {
          tmp_0 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(plus(a.conditions_1, b.conditions_1));
        } else {
          tmp_0 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(plus_0(a.conditions_1, b));
        }
        tmp = tmp_0;
      } else {
        if (a instanceof Equal()) {
          var tmp_1;
          if (b instanceof Equal()) {
            tmp_1 = equals(a.value_1, b.value_1) ? a : Never_getInstance();
          } else {
            if (b instanceof GreaterThan()) {
              var tmp_2;
              // Inline function 'kotlin.let' call
              var it = a.value_1;
              var tmp_3 = (!(it == null) ? isComparable(it) : false) ? it : THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_0 = b.value_1;
              var tmp$ret$2 = (!(it_0 == null) ? isComparable(it_0) : false) ? it_0 : THROW_CCE();
              if (compareTo(tmp_3, tmp$ret$2) > 0) {
                tmp_2 = a;
              } else {
                tmp_2 = Never_getInstance();
              }
              tmp_1 = tmp_2;
            } else {
              if (b instanceof LessThan()) {
                var tmp_4;
                // Inline function 'kotlin.let' call
                var it_1 = a.value_1;
                var tmp_5 = (!(it_1 == null) ? isComparable(it_1) : false) ? it_1 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_2 = b.value_1;
                var tmp$ret$6 = (!(it_2 == null) ? isComparable(it_2) : false) ? it_2 : THROW_CCE();
                if (compareTo(tmp_5, tmp$ret$6) < 0) {
                  tmp_4 = a;
                } else {
                  tmp_4 = Never_getInstance();
                }
                tmp_1 = tmp_4;
              } else {
                if (b instanceof GreaterThanOrEqual()) {
                  var tmp_6;
                  // Inline function 'kotlin.let' call
                  var it_3 = a.value_1;
                  var tmp_7 = (!(it_3 == null) ? isComparable(it_3) : false) ? it_3 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_4 = b.value_1;
                  var tmp$ret$10 = (!(it_4 == null) ? isComparable(it_4) : false) ? it_4 : THROW_CCE();
                  if (compareTo(tmp_7, tmp$ret$10) >= 0) {
                    tmp_6 = a;
                  } else {
                    tmp_6 = Never_getInstance();
                  }
                  tmp_1 = tmp_6;
                } else {
                  if (b instanceof LessThanOrEqual()) {
                    var tmp_8;
                    // Inline function 'kotlin.let' call
                    var it_5 = a.value_1;
                    var tmp_9 = (!(it_5 == null) ? isComparable(it_5) : false) ? it_5 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_6 = b.value_1;
                    var tmp$ret$14 = (!(it_6 == null) ? isComparable(it_6) : false) ? it_6 : THROW_CCE();
                    if (compareTo(tmp_9, tmp$ret$14) <= 0) {
                      tmp_8 = a;
                    } else {
                      tmp_8 = Never_getInstance();
                    }
                    tmp_1 = tmp_8;
                  } else {
                    if (b instanceof NotEqual()) {
                      tmp_1 = !equals(a.value_1, b.value_1) ? a : Never_getInstance();
                    } else {
                      if (b instanceof Inside()) {
                        tmp_1 = b.values_1.contains_aljjnj_k$(a.value_1) ? a : Never_getInstance();
                      } else {
                        if (b instanceof NotInside()) {
                          tmp_1 = !b.values_1.contains_aljjnj_k$(a.value_1) ? a : Never_getInstance();
                        } else {
                          if (b instanceof And()) {
                            tmp_1 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(plus_0(b.conditions_1, a));
                          } else {
                            tmp_1 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          tmp = tmp_1;
        } else {
          if (a instanceof GreaterThan()) {
            var tmp_10;
            if (b instanceof GreaterThan()) {
              var tmp_11;
              // Inline function 'kotlin.let' call
              var it_7 = a.value_1;
              var tmp_12 = (!(it_7 == null) ? isComparable(it_7) : false) ? it_7 : THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_8 = b.value_1;
              var tmp$ret$18 = (!(it_8 == null) ? isComparable(it_8) : false) ? it_8 : THROW_CCE();
              if (compareTo(tmp_12, tmp$ret$18) > 0) {
                tmp_11 = a;
              } else {
                tmp_11 = b;
              }
              tmp_10 = tmp_11;
            } else {
              if (b instanceof GreaterThanOrEqual()) {
                var tmp_13;
                // Inline function 'kotlin.let' call
                var it_9 = a.value_1;
                var tmp_14 = (!(it_9 == null) ? isComparable(it_9) : false) ? it_9 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_10 = b.value_1;
                var tmp$ret$22 = (!(it_10 == null) ? isComparable(it_10) : false) ? it_10 : THROW_CCE();
                if (compareTo(tmp_14, tmp$ret$22) >= 0) {
                  tmp_13 = a;
                } else {
                  tmp_13 = b;
                }
                tmp_10 = tmp_13;
              } else {
                if (b instanceof LessThan()) {
                  var tmp_15;
                  // Inline function 'kotlin.let' call
                  var it_11 = a.value_1;
                  var tmp_16 = (!(it_11 == null) ? isComparable(it_11) : false) ? it_11 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_12 = b.value_1;
                  var tmp$ret$26 = (!(it_12 == null) ? isComparable(it_12) : false) ? it_12 : THROW_CCE();
                  if (compareTo(tmp_16, tmp$ret$26) >= 0) {
                    tmp_15 = Never_getInstance();
                  } else {
                    tmp_15 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                  }
                  tmp_10 = tmp_15;
                } else {
                  if (b instanceof LessThanOrEqual()) {
                    var tmp_17;
                    // Inline function 'kotlin.let' call
                    var it_13 = a.value_1;
                    var tmp_18 = (!(it_13 == null) ? isComparable(it_13) : false) ? it_13 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_14 = b.value_1;
                    var tmp$ret$30 = (!(it_14 == null) ? isComparable(it_14) : false) ? it_14 : THROW_CCE();
                    if (compareTo(tmp_18, tmp$ret$30) >= 0) {
                      tmp_17 = Never_getInstance();
                    } else {
                      tmp_17 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                    }
                    tmp_10 = tmp_17;
                  } else {
                    var tmp_19;
                    var tmp_20;
                    if (b instanceof Always()) {
                      tmp_20 = true;
                    } else {
                      tmp_20 = b instanceof Never();
                    }
                    if (tmp_20) {
                      tmp_19 = true;
                    } else {
                      var tmp_21;
                      if (b instanceof And()) {
                        tmp_21 = true;
                      } else {
                        tmp_21 = b instanceof Equal();
                      }
                      tmp_19 = tmp_21;
                    }
                    if (tmp_19) {
                      tmp_10 = reduceAnd(b, a);
                    } else {
                      tmp_10 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                    }
                  }
                }
              }
            }
            tmp = tmp_10;
          } else {
            if (a instanceof LessThan()) {
              var tmp_22;
              if (b instanceof LessThan()) {
                var tmp_23;
                // Inline function 'kotlin.let' call
                var it_15 = a.value_1;
                var tmp_24 = (!(it_15 == null) ? isComparable(it_15) : false) ? it_15 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_16 = b.value_1;
                var tmp$ret$34 = (!(it_16 == null) ? isComparable(it_16) : false) ? it_16 : THROW_CCE();
                if (compareTo(tmp_24, tmp$ret$34) < 0) {
                  tmp_23 = a;
                } else {
                  tmp_23 = b;
                }
                tmp_22 = tmp_23;
              } else {
                if (b instanceof LessThanOrEqual()) {
                  var tmp_25;
                  // Inline function 'kotlin.let' call
                  var it_17 = a.value_1;
                  var tmp_26 = (!(it_17 == null) ? isComparable(it_17) : false) ? it_17 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_18 = b.value_1;
                  var tmp$ret$38 = (!(it_18 == null) ? isComparable(it_18) : false) ? it_18 : THROW_CCE();
                  if (compareTo(tmp_26, tmp$ret$38) <= 0) {
                    tmp_25 = a;
                  } else {
                    tmp_25 = b;
                  }
                  tmp_22 = tmp_25;
                } else {
                  var tmp_27;
                  var tmp_28;
                  if (b instanceof GreaterThan()) {
                    tmp_28 = true;
                  } else {
                    var tmp_29;
                    if (b instanceof GreaterThanOrEqual()) {
                      tmp_29 = true;
                    } else {
                      tmp_29 = b instanceof Always();
                    }
                    tmp_28 = tmp_29;
                  }
                  if (tmp_28) {
                    tmp_27 = true;
                  } else {
                    var tmp_30;
                    if (b instanceof Never()) {
                      tmp_30 = true;
                    } else {
                      var tmp_31;
                      if (b instanceof And()) {
                        tmp_31 = true;
                      } else {
                        tmp_31 = b instanceof Equal();
                      }
                      tmp_30 = tmp_31;
                    }
                    tmp_27 = tmp_30;
                  }
                  if (tmp_27) {
                    tmp_22 = reduceAnd(b, a);
                  } else {
                    tmp_22 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                  }
                }
              }
              tmp = tmp_22;
            } else {
              if (a instanceof GreaterThanOrEqual()) {
                var tmp_32;
                if (b instanceof GreaterThanOrEqual()) {
                  var tmp_33;
                  // Inline function 'kotlin.let' call
                  var it_19 = a.value_1;
                  var tmp_34 = (!(it_19 == null) ? isComparable(it_19) : false) ? it_19 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_20 = b.value_1;
                  var tmp$ret$42 = (!(it_20 == null) ? isComparable(it_20) : false) ? it_20 : THROW_CCE();
                  if (compareTo(tmp_34, tmp$ret$42) >= 0) {
                    tmp_33 = a;
                  } else {
                    tmp_33 = b;
                  }
                  tmp_32 = tmp_33;
                } else {
                  if (b instanceof LessThan()) {
                    var tmp_35;
                    // Inline function 'kotlin.let' call
                    var it_21 = a.value_1;
                    var tmp_36 = (!(it_21 == null) ? isComparable(it_21) : false) ? it_21 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_22 = b.value_1;
                    var tmp$ret$46 = (!(it_22 == null) ? isComparable(it_22) : false) ? it_22 : THROW_CCE();
                    if (compareTo(tmp_36, tmp$ret$46) >= 0) {
                      tmp_35 = Never_getInstance();
                    } else {
                      tmp_35 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                    }
                    tmp_32 = tmp_35;
                  } else {
                    if (b instanceof LessThanOrEqual()) {
                      var tmp_37;
                      // Inline function 'kotlin.let' call
                      var it_23 = a.value_1;
                      var tmp_38 = (!(it_23 == null) ? isComparable(it_23) : false) ? it_23 : THROW_CCE();
                      // Inline function 'kotlin.let' call
                      var it_24 = b.value_1;
                      var tmp$ret$50 = (!(it_24 == null) ? isComparable(it_24) : false) ? it_24 : THROW_CCE();
                      if (compareTo(tmp_38, tmp$ret$50) > 0) {
                        tmp_37 = Never_getInstance();
                      } else {
                        tmp_37 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                      }
                      tmp_32 = tmp_37;
                    } else {
                      var tmp_39;
                      var tmp_40;
                      if (b instanceof GreaterThan()) {
                        tmp_40 = true;
                      } else {
                        tmp_40 = b instanceof Always();
                      }
                      if (tmp_40) {
                        tmp_39 = true;
                      } else {
                        var tmp_41;
                        if (b instanceof Never()) {
                          tmp_41 = true;
                        } else {
                          var tmp_42;
                          if (b instanceof And()) {
                            tmp_42 = true;
                          } else {
                            tmp_42 = b instanceof Equal();
                          }
                          tmp_41 = tmp_42;
                        }
                        tmp_39 = tmp_41;
                      }
                      if (tmp_39) {
                        tmp_32 = reduceAnd(b, a);
                      } else {
                        tmp_32 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                      }
                    }
                  }
                }
                tmp = tmp_32;
              } else {
                if (a instanceof LessThanOrEqual()) {
                  var tmp_43;
                  if (b instanceof LessThanOrEqual()) {
                    var tmp_44;
                    // Inline function 'kotlin.let' call
                    var it_25 = a.value_1;
                    var tmp_45 = (!(it_25 == null) ? isComparable(it_25) : false) ? it_25 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_26 = b.value_1;
                    var tmp$ret$54 = (!(it_26 == null) ? isComparable(it_26) : false) ? it_26 : THROW_CCE();
                    if (compareTo(tmp_45, tmp$ret$54) <= 0) {
                      tmp_44 = a;
                    } else {
                      tmp_44 = b;
                    }
                    tmp_43 = tmp_44;
                  } else {
                    var tmp_46;
                    var tmp_47;
                    if (b instanceof LessThan()) {
                      tmp_47 = true;
                    } else {
                      tmp_47 = b instanceof Always();
                    }
                    if (tmp_47) {
                      tmp_46 = true;
                    } else {
                      var tmp_48;
                      if (b instanceof Never()) {
                        tmp_48 = true;
                      } else {
                        var tmp_49;
                        if (b instanceof And()) {
                          tmp_49 = true;
                        } else {
                          tmp_49 = b instanceof Equal();
                        }
                        tmp_48 = tmp_49;
                      }
                      tmp_46 = tmp_48;
                    }
                    if (tmp_46) {
                      tmp_43 = reduceAnd(b, a);
                    } else {
                      tmp_43 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                    }
                  }
                  tmp = tmp_43;
                } else {
                  if (a instanceof Inside()) {
                    var tmp_50;
                    if (b instanceof Inside()) {
                      tmp_50 = Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(intersect(toSet(a.values_1), toSet(b.values_1)));
                    } else {
                      if (b instanceof NotInside()) {
                        tmp_50 = Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(minus(toSet(a.values_1), toSet(b.values_1)));
                      } else {
                        var tmp_51;
                        var tmp_52;
                        if (b instanceof GreaterThan()) {
                          tmp_52 = true;
                        } else {
                          var tmp_53;
                          if (b instanceof LessThan()) {
                            tmp_53 = true;
                          } else {
                            tmp_53 = b instanceof Always();
                          }
                          tmp_52 = tmp_53;
                        }
                        if (tmp_52) {
                          tmp_51 = true;
                        } else {
                          var tmp_54;
                          if (b instanceof Never()) {
                            tmp_54 = true;
                          } else {
                            var tmp_55;
                            if (b instanceof And()) {
                              tmp_55 = true;
                            } else {
                              tmp_55 = b instanceof Equal();
                            }
                            tmp_54 = tmp_55;
                          }
                          tmp_51 = tmp_54;
                        }
                        if (tmp_51) {
                          tmp_50 = reduceAnd(b, a);
                        } else {
                          tmp_50 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                        }
                      }
                    }
                    tmp = tmp_50;
                  } else {
                    if (a instanceof NotInside()) {
                      var tmp_56;
                      if (b instanceof NotInside()) {
                        tmp_56 = NotInside().new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(union(toSet(a.values_1), toSet(b.values_1)));
                      } else {
                        var tmp_57;
                        var tmp_58;
                        if (b instanceof Inside()) {
                          tmp_58 = true;
                        } else {
                          var tmp_59;
                          if (b instanceof GreaterThan()) {
                            tmp_59 = true;
                          } else {
                            tmp_59 = b instanceof LessThan();
                          }
                          tmp_58 = tmp_59;
                        }
                        if (tmp_58) {
                          tmp_57 = true;
                        } else {
                          var tmp_60;
                          var tmp_61;
                          if (b instanceof Always()) {
                            tmp_61 = true;
                          } else {
                            tmp_61 = b instanceof Never();
                          }
                          if (tmp_61) {
                            tmp_60 = true;
                          } else {
                            var tmp_62;
                            if (b instanceof And()) {
                              tmp_62 = true;
                            } else {
                              tmp_62 = b instanceof Equal();
                            }
                            tmp_60 = tmp_62;
                          }
                          tmp_57 = tmp_60;
                        }
                        if (tmp_57) {
                          tmp_56 = reduceAnd(b, a);
                        } else {
                          tmp_56 = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                        }
                      }
                      tmp = tmp_56;
                    } else {
                      tmp = And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([a, b]));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function make(prop, cond) {
  var tmp;
  if (prop.isEmpty_y1axqb_k$()) {
    tmp = cond;
  } else {
    var tmp_0 = first(prop);
    var tmp_1 = isInterface(tmp_0, SerializableProperty()) ? tmp_0 : THROW_CCE();
    var tmp_2 = make(prop.subList_xle3r2_k$(1, prop.get_size_woubt6_k$()), cond);
    tmp = OnField().new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(tmp_1, tmp_2 instanceof Condition() ? tmp_2 : THROW_CCE());
  }
  return tmp;
}
function orByField(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof Or()) {
    var tmp_0 = asSequence(_this__u8e3s4.conditions_1);
    tmp = flatMap(tmp_0, orByField$lambda);
  } else {
    if (_this__u8e3s4 instanceof OnField()) {
      var tmp_1 = orByField(_this__u8e3s4.condition_1);
      tmp = map(tmp_1, (it) => to(plus(listOf_0(_this__u8e3s4.key_1), it.first_1), it.second_1));
    } else {
      var s = simplify(_this__u8e3s4);
      var tmp_2;
      if (s instanceof OnField()) {
        var tmp_3 = orByField(s.condition_1);
        tmp_2 = map(tmp_3, (it) => to(plus(listOf_0(s.key_1), it.first_1), it.second_1));
      } else {
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_2 = sequenceOf(to(tmp$ret$0, s));
      }
      tmp = tmp_2;
    }
  }
  return tmp;
}
function reduceOr(a, b) {
  var tmp;
  if (a instanceof Always()) {
    tmp = a;
  } else {
    if (a instanceof Never()) {
      tmp = b;
    } else {
      if (a instanceof Or()) {
        var tmp_0;
        if (b instanceof Or()) {
          tmp_0 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(plus(a.conditions_1, b.conditions_1));
        } else {
          tmp_0 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(plus_0(a.conditions_1, b));
        }
        tmp = tmp_0;
      } else {
        if (a instanceof Equal()) {
          var tmp_1;
          if (b instanceof Equal()) {
            tmp_1 = equals(a.value_1, b.value_1) ? a : Inside().new_com_lightningkite_services_database_Condition_Inside_16ypu3_k$(listOf([a.value_1, b.value_1]));
          } else {
            if (b instanceof GreaterThan()) {
              var tmp_2;
              // Inline function 'kotlin.let' call
              var it = a.value_1;
              var tmp_3 = (!(it == null) ? isComparable(it) : false) ? it : THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_0 = b.value_1;
              var tmp$ret$2 = (!(it_0 == null) ? isComparable(it_0) : false) ? it_0 : THROW_CCE();
              if (compareTo(tmp_3, tmp$ret$2) > 0) {
                tmp_2 = b;
              } else {
                tmp_2 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
              }
              tmp_1 = tmp_2;
            } else {
              if (b instanceof LessThan()) {
                var tmp_4;
                // Inline function 'kotlin.let' call
                var it_1 = a.value_1;
                var tmp_5 = (!(it_1 == null) ? isComparable(it_1) : false) ? it_1 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_2 = b.value_1;
                var tmp$ret$6 = (!(it_2 == null) ? isComparable(it_2) : false) ? it_2 : THROW_CCE();
                if (compareTo(tmp_5, tmp$ret$6) < 0) {
                  tmp_4 = b;
                } else {
                  tmp_4 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                }
                tmp_1 = tmp_4;
              } else {
                if (b instanceof GreaterThanOrEqual()) {
                  var tmp_6;
                  // Inline function 'kotlin.let' call
                  var it_3 = a.value_1;
                  var tmp_7 = (!(it_3 == null) ? isComparable(it_3) : false) ? it_3 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_4 = b.value_1;
                  var tmp$ret$10 = (!(it_4 == null) ? isComparable(it_4) : false) ? it_4 : THROW_CCE();
                  if (compareTo(tmp_7, tmp$ret$10) >= 0) {
                    tmp_6 = b;
                  } else {
                    tmp_6 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                  }
                  tmp_1 = tmp_6;
                } else {
                  if (b instanceof LessThanOrEqual()) {
                    var tmp_8;
                    // Inline function 'kotlin.let' call
                    var it_5 = a.value_1;
                    var tmp_9 = (!(it_5 == null) ? isComparable(it_5) : false) ? it_5 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_6 = b.value_1;
                    var tmp$ret$14 = (!(it_6 == null) ? isComparable(it_6) : false) ? it_6 : THROW_CCE();
                    if (compareTo(tmp_9, tmp$ret$14) <= 0) {
                      tmp_8 = b;
                    } else {
                      tmp_8 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                    }
                    tmp_1 = tmp_8;
                  } else {
                    if (b instanceof NotEqual()) {
                      tmp_1 = !equals(a.value_1, b.value_1) ? b : Always_getInstance();
                    } else {
                      if (b instanceof Inside()) {
                        tmp_1 = b.values_1.contains_aljjnj_k$(a.value_1) ? b : Inside().new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(plus_1(b.values_1, a.value_1));
                      } else {
                        if (b instanceof NotInside()) {
                          tmp_1 = !b.values_1.contains_aljjnj_k$(a.value_1) ? b : NotInside().new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(minus_0(b.values_1, a.value_1));
                        } else {
                          if (b instanceof Or()) {
                            tmp_1 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(plus_0(b.conditions_1, a));
                          } else {
                            tmp_1 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          tmp = tmp_1;
        } else {
          if (a instanceof GreaterThan()) {
            var tmp_10;
            if (b instanceof GreaterThan()) {
              var tmp_11;
              // Inline function 'kotlin.let' call
              var it_7 = a.value_1;
              var tmp_12 = (!(it_7 == null) ? isComparable(it_7) : false) ? it_7 : THROW_CCE();
              // Inline function 'kotlin.let' call
              var it_8 = b.value_1;
              var tmp$ret$18 = (!(it_8 == null) ? isComparable(it_8) : false) ? it_8 : THROW_CCE();
              if (compareTo(tmp_12, tmp$ret$18) > 0) {
                tmp_11 = b;
              } else {
                tmp_11 = a;
              }
              tmp_10 = tmp_11;
            } else {
              if (b instanceof GreaterThanOrEqual()) {
                var tmp_13;
                // Inline function 'kotlin.let' call
                var it_9 = a.value_1;
                var tmp_14 = (!(it_9 == null) ? isComparable(it_9) : false) ? it_9 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_10 = b.value_1;
                var tmp$ret$22 = (!(it_10 == null) ? isComparable(it_10) : false) ? it_10 : THROW_CCE();
                if (compareTo(tmp_14, tmp$ret$22) >= 0) {
                  tmp_13 = b;
                } else {
                  tmp_13 = a;
                }
                tmp_10 = tmp_13;
              } else {
                var tmp_15;
                var tmp_16;
                if (b instanceof Always()) {
                  tmp_16 = true;
                } else {
                  tmp_16 = b instanceof Never();
                }
                if (tmp_16) {
                  tmp_15 = true;
                } else {
                  var tmp_17;
                  if (b instanceof Or()) {
                    tmp_17 = true;
                  } else {
                    tmp_17 = b instanceof Equal();
                  }
                  tmp_15 = tmp_17;
                }
                if (tmp_15) {
                  tmp_10 = reduceOr(b, a);
                } else {
                  tmp_10 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                }
              }
            }
            tmp = tmp_10;
          } else {
            if (a instanceof LessThan()) {
              var tmp_18;
              if (b instanceof LessThan()) {
                var tmp_19;
                // Inline function 'kotlin.let' call
                var it_11 = a.value_1;
                var tmp_20 = (!(it_11 == null) ? isComparable(it_11) : false) ? it_11 : THROW_CCE();
                // Inline function 'kotlin.let' call
                var it_12 = b.value_1;
                var tmp$ret$26 = (!(it_12 == null) ? isComparable(it_12) : false) ? it_12 : THROW_CCE();
                if (compareTo(tmp_20, tmp$ret$26) < 0) {
                  tmp_19 = b;
                } else {
                  tmp_19 = a;
                }
                tmp_18 = tmp_19;
              } else {
                if (b instanceof LessThanOrEqual()) {
                  var tmp_21;
                  // Inline function 'kotlin.let' call
                  var it_13 = a.value_1;
                  var tmp_22 = (!(it_13 == null) ? isComparable(it_13) : false) ? it_13 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_14 = b.value_1;
                  var tmp$ret$30 = (!(it_14 == null) ? isComparable(it_14) : false) ? it_14 : THROW_CCE();
                  if (compareTo(tmp_22, tmp$ret$30) <= 0) {
                    tmp_21 = b;
                  } else {
                    tmp_21 = a;
                  }
                  tmp_18 = tmp_21;
                } else {
                  var tmp_23;
                  var tmp_24;
                  if (b instanceof Always()) {
                    tmp_24 = true;
                  } else {
                    tmp_24 = b instanceof Never();
                  }
                  if (tmp_24) {
                    tmp_23 = true;
                  } else {
                    var tmp_25;
                    if (b instanceof Or()) {
                      tmp_25 = true;
                    } else {
                      tmp_25 = b instanceof Equal();
                    }
                    tmp_23 = tmp_25;
                  }
                  if (tmp_23) {
                    tmp_18 = reduceOr(b, a);
                  } else {
                    tmp_18 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                  }
                }
              }
              tmp = tmp_18;
            } else {
              if (a instanceof GreaterThanOrEqual()) {
                var tmp_26;
                if (b instanceof GreaterThanOrEqual()) {
                  var tmp_27;
                  // Inline function 'kotlin.let' call
                  var it_15 = a.value_1;
                  var tmp_28 = (!(it_15 == null) ? isComparable(it_15) : false) ? it_15 : THROW_CCE();
                  // Inline function 'kotlin.let' call
                  var it_16 = b.value_1;
                  var tmp$ret$34 = (!(it_16 == null) ? isComparable(it_16) : false) ? it_16 : THROW_CCE();
                  if (compareTo(tmp_28, tmp$ret$34) >= 0) {
                    tmp_27 = b;
                  } else {
                    tmp_27 = a;
                  }
                  tmp_26 = tmp_27;
                } else {
                  var tmp_29;
                  var tmp_30;
                  if (b instanceof GreaterThan()) {
                    tmp_30 = true;
                  } else {
                    tmp_30 = b instanceof Always();
                  }
                  if (tmp_30) {
                    tmp_29 = true;
                  } else {
                    var tmp_31;
                    if (b instanceof Never()) {
                      tmp_31 = true;
                    } else {
                      var tmp_32;
                      if (b instanceof Or()) {
                        tmp_32 = true;
                      } else {
                        tmp_32 = b instanceof Equal();
                      }
                      tmp_31 = tmp_32;
                    }
                    tmp_29 = tmp_31;
                  }
                  if (tmp_29) {
                    tmp_26 = reduceOr(b, a);
                  } else {
                    tmp_26 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                  }
                }
                tmp = tmp_26;
              } else {
                if (a instanceof LessThanOrEqual()) {
                  var tmp_33;
                  if (b instanceof LessThanOrEqual()) {
                    var tmp_34;
                    // Inline function 'kotlin.let' call
                    var it_17 = a.value_1;
                    var tmp_35 = (!(it_17 == null) ? isComparable(it_17) : false) ? it_17 : THROW_CCE();
                    // Inline function 'kotlin.let' call
                    var it_18 = b.value_1;
                    var tmp$ret$38 = (!(it_18 == null) ? isComparable(it_18) : false) ? it_18 : THROW_CCE();
                    if (compareTo(tmp_35, tmp$ret$38) <= 0) {
                      tmp_34 = b;
                    } else {
                      tmp_34 = a;
                    }
                    tmp_33 = tmp_34;
                  } else {
                    var tmp_36;
                    var tmp_37;
                    if (b instanceof LessThan()) {
                      tmp_37 = true;
                    } else {
                      tmp_37 = b instanceof Always();
                    }
                    if (tmp_37) {
                      tmp_36 = true;
                    } else {
                      var tmp_38;
                      if (b instanceof Never()) {
                        tmp_38 = true;
                      } else {
                        var tmp_39;
                        if (b instanceof Or()) {
                          tmp_39 = true;
                        } else {
                          tmp_39 = b instanceof Equal();
                        }
                        tmp_38 = tmp_39;
                      }
                      tmp_36 = tmp_38;
                    }
                    if (tmp_36) {
                      tmp_33 = reduceOr(b, a);
                    } else {
                      tmp_33 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                    }
                  }
                  tmp = tmp_33;
                } else {
                  if (a instanceof Inside()) {
                    var tmp_40;
                    if (b instanceof Inside()) {
                      tmp_40 = Inside().new_com_lightningkite_services_database_Condition_Inside_16ypu3_k$(toList(union(toSet(a.values_1), toSet(b.values_1))));
                    } else {
                      if (b instanceof NotInside()) {
                        tmp_40 = NotInside().new_com_lightningkite_services_database_Condition_NotInside_85h2wk_k$(toList(minus(toSet(b.values_1), toSet(a.values_1))));
                      } else {
                        var tmp_41;
                        var tmp_42;
                        if (b instanceof GreaterThan()) {
                          tmp_42 = true;
                        } else {
                          var tmp_43;
                          if (b instanceof LessThan()) {
                            tmp_43 = true;
                          } else {
                            tmp_43 = b instanceof Always();
                          }
                          tmp_42 = tmp_43;
                        }
                        if (tmp_42) {
                          tmp_41 = true;
                        } else {
                          var tmp_44;
                          if (b instanceof Never()) {
                            tmp_44 = true;
                          } else {
                            var tmp_45;
                            if (b instanceof Or()) {
                              tmp_45 = true;
                            } else {
                              tmp_45 = b instanceof Equal();
                            }
                            tmp_44 = tmp_45;
                          }
                          tmp_41 = tmp_44;
                        }
                        if (tmp_41) {
                          tmp_40 = reduceOr(b, a);
                        } else {
                          tmp_40 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                        }
                      }
                    }
                    tmp = tmp_40;
                  } else {
                    if (a instanceof NotInside()) {
                      var tmp_46;
                      if (b instanceof NotInside()) {
                        tmp_46 = NotInside().new_com_lightningkite_services_database_Condition_NotInside_85h2wk_k$(toList(intersect(toSet(a.values_1), toSet(b.values_1))));
                      } else {
                        var tmp_47;
                        var tmp_48;
                        if (b instanceof Inside()) {
                          tmp_48 = true;
                        } else {
                          var tmp_49;
                          if (b instanceof GreaterThan()) {
                            tmp_49 = true;
                          } else {
                            tmp_49 = b instanceof LessThan();
                          }
                          tmp_48 = tmp_49;
                        }
                        if (tmp_48) {
                          tmp_47 = true;
                        } else {
                          var tmp_50;
                          var tmp_51;
                          if (b instanceof Always()) {
                            tmp_51 = true;
                          } else {
                            tmp_51 = b instanceof Never();
                          }
                          if (tmp_51) {
                            tmp_50 = true;
                          } else {
                            var tmp_52;
                            if (b instanceof Or()) {
                              tmp_52 = true;
                            } else {
                              tmp_52 = b instanceof Equal();
                            }
                            tmp_50 = tmp_52;
                          }
                          tmp_47 = tmp_50;
                        }
                        if (tmp_47) {
                          tmp_46 = reduceOr(b, a);
                        } else {
                          tmp_46 = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                        }
                      }
                      tmp = tmp_46;
                    } else {
                      tmp = Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([a, b]));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function simplify$lambda(it) {
  return andByField(it);
}
function simplify$lambda_0(it) {
  return orByField(it);
}
function andByField$lambda(it) {
  return andByField(it);
}
function orByField$lambda(it) {
  return orByField(it);
}
//region block: exports
export {
  simplify as simplify209licccqij7m,
};
//endregion

//# sourceMappingURL=ConditionSimplify.mjs.map
